/* MH v9: compact announcement with explicit order-wide discount, preserved promotion/calendar API. */
(function () {
  'use strict';
  function currentPromotion() { return window.MHPromo ? window.MHPromo.getActivePromotion() : null; }
  function renderAnnouncement() {
    var bar = document.getElementById('mainTopbar'), inner = document.getElementById('topbarInner');
    if (!bar || !inner) return;
    var p = currentPromotion();
    bar.classList.toggle('promo-active', Boolean(p));
    document.body.classList.add('has-promo-bar');
    var message = inner.querySelector('#mh27TopbarMessage');
    if (message) message.textContent = p ? p.discount + ' em toda a encomenda · ' + p.code + ' ' + p.deadline + '.' : 'Sem subscrição';
  }
  function renderNav() {
    var promo = currentPromotion(), button = document.getElementById('navPromoBtn'), normal = document.getElementById('navNormalBtn');
    if (!button || !normal) return;
    button.style.display = promo ? 'inline-flex' : 'none';
    normal.style.display = promo ? 'none' : 'inline-flex';
    if (promo) { button.dataset.promoCode = promo.code; button.href = '/?open_order=1&intent=gift&promo=' + encodeURIComponent(promo.code); }
    else { delete button.dataset.promoCode; button.href = '/?open_order=1&intent=gift'; }
  }
  window.toggleMobileMenu = function () {
    var menu = document.getElementById('navMobile'), burger = document.getElementById('navBurger');
    if (!menu || !burger) return;
    if (menu.classList.contains('open')) { window.closeMobileMenu(); return; }
    menu.classList.add('open'); menu.inert = false; menu.setAttribute('aria-hidden', 'false');
    burger.classList.add('open'); burger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    menu.scrollTop = 0;
  };
  window.closeMobileMenu = function () {
    var menu = document.getElementById('navMobile'), burger = document.getElementById('navBurger');
    if (menu) { menu.classList.remove('open'); menu.inert = true; menu.setAttribute('aria-hidden', 'true'); }
    if (burger) { burger.classList.remove('open'); burger.setAttribute('aria-expanded', 'false'); }
    document.body.style.overflow = '';
  };
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && document.getElementById('navMobile')?.classList.contains('open')) {
      window.closeMobileMenu();
      document.getElementById('navBurger')?.focus();
    }
  });
  var pending = 0;
  window.addEventListener('scroll', function () {
    if (pending) return;
    pending = requestAnimationFrame(function () { pending = 0; var nav = document.getElementById('mainNav'); if (nav) nav.classList.toggle('nav-scrolled-light', window.scrollY > 40); });
  }, {passive: true});
  var menuLastWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    var width = window.innerWidth;
    if (Math.abs(width - menuLastWidth) < 2) return;
    menuLastWidth = width;
    if (width >= 1280) window.closeMobileMenu();
  }, {passive: true});
  function init() { renderAnnouncement(); renderNav(); }
  var lastBarHeight = 0;
  function syncBarHeight() {
    var bar = document.getElementById('mainTopbar');
    if (!bar) return;
    var height = Math.ceil(bar.getBoundingClientRect().height);
    if (height === lastBarHeight || height <= 0) return;
    lastBarHeight = height;
    document.documentElement.style.setProperty('--mh-v8-announcement-height', height + 'px');
    // mh-header-offset.js observa o tamanho por ResizeObserver.
    // Não emitir um resize global (causava recálculos de layout durante o LCP).
  }
  function watchBar() {
    var bar = document.getElementById('mainTopbar');
    if (bar && 'ResizeObserver' in window) new ResizeObserver(syncBarHeight).observe(bar);
    syncBarHeight();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchBar, {once: true}); else watchBar();
  document.addEventListener('mh:promotion-change', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true}); else init();
})();
